import ModalNewComentario from './ModalNewComentario';

export default ModalNewComentario;
